<template>
  <div class="page-container">
    <GameIframe :gameInfo="gameInfo" :play="playGame" v-if="playGame"/>
    <TopBack :title="activityName"/>
    <div style="margin-top: 10px">
        <img src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/banners/banner-ipl.jpg" class="header-image" />
    </div>
    <div class="nav">
      <div class="nav-item" :class="{active: type==='rank'}" @click="type = 'rank'">{{$t('lang.gameCompetition.ipl.iplRewardNav')}}</div>
      <div class="nav-item" :class="{active: type==='rules'}" @click="type = 'rules'">{{$t('lang.gameCompetition.howToPlay')}}</div>
    </div>
    <div class="tab" v-show="type==='rank'">
      <div class="rank-item">
        <div class="rank-no">
          <span>{{$t('lang.gameCompetition.ipl.weeklyBet')}}</span>
        </div>
        <div class="rank-content" style="background: none">
          <div class="rank-username">
            <span>{{$t('lang.gameCompetition.ipl.cashReward')}}</span>
          </div>
        </div>
      </div>
      <div v-for="(item, index) in list"
           :key="index" class="rank-item">
        <div class="rank-no">
          <span>≥ {{userInfo?fetchCurrency[userInfo.CurrencyName]:''}}{{item.BetAmount}}</span>
        </div>
        <div class="rank-content">
          <span>{{userInfo?fetchCurrency[userInfo.CurrencyName]:''}}{{item.RewardAmount}}</span>
        </div>
      </div>

      <div v-if="userInfo && userInfo.UserId">
        <div class="rank-splitter"></div>
        <div class="rank-item" >
          <div class="rank-no">
            <span>{{$t('lang.gameCompetition.ipl.weekBet')}}</span>
          </div>
          <div class="rank-content">
            <span>{{userInfo?fetchCurrency[userInfo.CurrencyName]:''}}{{weekBet}}</span>
          </div>
        </div>
        <div class="rank-item" >
          <div class="rank-no">
            <span>{{$t('lang.gameCompetition.ipl.totalBet')}}</span>
          </div>
          <div class="rank-content">
            <span>{{userInfo?fetchCurrency[userInfo.CurrencyName]:''}}{{totalBet}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="tab rules" v-show="type==='rules'">
      <div v-for="(item, index) in $t('lang.gameCompetition.ipl.rules')"
           :key="index">
        <div class="rule-item">
          <div class="rule-number">
            <span>{{index+1}}</span>
          </div>
          <div class="rule-content">
            <div class="rule-title">
              <span>{{item}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="play-btn"
         @click="fetchGame(gameCode, gameProviderId, gameImg, gameName)">
      <span>{{$t('lang.common.play')}}</span>
    </div>
  </div>
</template>

<script>
// import store from '../../store/store'
import {Toast} from 'mint-ui'
import request from '@/service'
import TopBack from '@/components/TopBack/index'
import GameIframe from '@/components/GameIframe/index'
import {fetchCurrency} from '@/constant'

export default {
  name: 'GameCompetition2',
  components: {
    TopBack,
    GameIframe
  },
  data () {
    return {
      type: 'rank',
      list: [],
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      hasLoadAll: false,
      activityCode: '',
      activityName: '',
      gameCode: '',
      gameProviderId: '',
      gameName: '',
      gameImg: '',
      playGame: false,
      playVideo: false,
      gameInfo: {},
      fetchCurrency,
      weekBet: 0,
      totalBet: 0
    }
  },
  mounted () {
    this.getActivityInfo()
  },
  methods: {
    getActivityInfo () {
      const data = {
        UserId: this.userInfo.UserId,
        ActivityCode: this.activityCode,
        internation: this.$store.state.internation
      }
      request('post', '/innovation/activity/getgameactivityinfo', data)
        .then(res => {
          this.list = res.list
          this.activityName = res.ActivityName
          this.gameCode = res.gameCode
          this.gameProviderId = res.gameProviderId
          this.gameName = res.gameName
          this.gameImg = res.gameImage
          this.weekBet = res.weekBet
          this.totalBet = res.totalBet
        })
    },
    fetchGame (gameCode, gameProviderId, gameImg, gameNameEn) {
      if (this.userInfo) {
        if (this.userInfo && this.$store.state.banUserId.includes(this.userInfo.UserId)) {
          Toast(this.$t('lang.home.gameMaintenancePrompt'))
          return
        }
        const url = '/innovation/game/getgameurl'
        const data = {
          userId: this.userInfo.UserId || '',
          gameCode: gameCode,
          gameProviderId: gameProviderId,
          deviceWidth: document.body.clientWidth,
          lang: localStorage.getItem('locale')
        }
        request('post', url, data).then(res => {
          console.log(res)
          if (res.Url) {
            this.gameInfo = {
              gameUrl: res.Url,
              gameImg: gameImg,
              gameName: gameNameEn
            }
            this.showGame = true
            this.playGame = true
          } else {
            Toast(this.$t('lang.home.gameMaintenancePrompt'))
          }
        }).catch(err => {
          console.log(err)
          Toast(Toast(this.$t('lang.home.gameMaintenancePrompt')))
        })
      } else {
        this.$router.push('/Login')
      }
    },
    close () {
      this.playGame = false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.activityCode = to.query.param
    })
  }
}
</script>

<style scoped lang="less" >
  .page-container{
    .header-image{
      width: 100%;
      display: block;
    }

    .nav{
      display: flex;
      margin: 15px 10px 20px 10px;
      border-radius: 6px;
      border: 1px solid rgba(246, 217,170, 0.5);

      .nav-item{
        flex: 1;
        line-height: 30px;
        text-align: center;
      }

      .active{
        background: #F6D9AA;
        color: #543200;
        border-radius: 6px;
      }
    }

    .rank-item {
      margin: 5px 10px;
      display: flex;
      line-height: 25px;
      text-align: center;
      color: #EFEFEF;

      .rank-no {
        flex: 1;
        height: 25px;
        background-size: contain;
      }

      .rank-content {
        margin: 0 0 0 0;
        flex: 1;
        border-radius: 52px;
      }
    }

    .rank-splitter {
      margin: 15px 10px 15px 10px;
      border-bottom: 1px solid #FFFFFF;
    }

    .rules{
      margin: 0px 10px 0px 10px;

      .rule-item{
        display: flex;
        margin-bottom: 10px;
        .rule-number{
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 1px solid #F6D9AA;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          color: #F6D9AA;
        }
        .rule-content{
          width: calc(100vw - 32px - 40px);
          padding: 0 0px 0 10px;
          .rule-title{
            color: #F6D9AA;
            font-size: 16px;
            line-height: 20px;
            margin: 0 0 5px 0;
          }
          .rule-description{
            color: #DADADA;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }

    .play-btn{
      background: #F6D9AA;
      border-radius: 6px;
      line-height: 20px;
      padding: 12px 0px;
      text-align: center;
      color: #000D2E;
      font-size: 20px;
      margin: 30px 10px 30px 10px;
    }

    .showMore {
      text-align: center;
      img {
        width: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/GameCompetition/competition2.vue